export const SDK_CREDENTIAL_SIGNATURE_STORAGE_KEY =
  "gluedin_sdk_credentials_signature";

export const SDK_SESSION_STORAGE_KEYS = [
  "guestToken",
  "userAccessToken",
  "projectSecrets",
  "community-closed",
  "guestTokenExpiry",
  "userTokenExpiry",
  "userRefreshToken",
];
